import React from 'react'
import {MDBBox, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import './MobileNumberEntry.scss'
import RequestOtpMutation from "../../mutations/RequestOtpMutation";
import cogoToast from 'cogo-toast';
import {connect} from "react-redux";
import {setLoginStep, userLogin} from "../../Actions";
import LoginHeader from "../../component/LoginHeader/LoginHeader";
import TermsAndConditionContent from "../../component/TermsAndConditionContent/TermsAndConditionContent";
import {Slide} from "react-reveal";
import {withRouter} from "react-router-dom";
import {assetUrl} from "../../serviceApi";

const Phone = assetUrl+'images/login-mobile.png'
const envelope = assetUrl+'images/animation_closed_envelope.svg'
const netaLogo = assetUrl+'images/neta-logo-sm.png';
const whiteArrow = assetUrl+'images/white-arrow-right.png'




class MobileNumberEntry extends React.Component {

	state = {
		mobileno: "",
		loading: false,
		open_modal: false,
		trigger: false,
		validated: false
	}

	handleInpuChange = (e) => {
		if(e.target.value.length <11){
			this.setState({
				mobileno: (e.target.validity.valid) ? e.target.value : this.state.mobileno
			})
		}
	}

	componentDidMount() {
		this.setState({...this.state, trigger: true})
		if(this.props.user_details.mobileNumber){
			this.setState({
				mobileno:parseInt(this.props.user_details.mobileNumber)
			})
		}
	}



	rippleEffect = (e) => {
		if (this.state.validated === false) {

			let x = e.clientX;
			// let y = e.clientY;
			// let buttonTop = e.target.offsetTop;
			let buttonLeft = e.target.offsetLeft;
			let xInside = x - buttonLeft;
			// let yInside = y - buttonTop;

			let circle = document.createElement('span');
			circle.classList.add('mob-circle');
			// circle.style.top = yInside + 'px';
			circle.style.left = xInside + 'px';
			if (document.querySelector("#submitButton-mobile")) {

				document.querySelector("#submitButton-mobile").appendChild(circle);

				setTimeout(() => {

					circle.remove();

				}, 100);

			}
		}
	}

	handleSubmit = (e) => {
		// this.setState({...this.state, trigger: true})
		// this.rippleEffect(e)
		let data = {
			'mobileNumber': "+91" + this.state.mobileno,
		}
		let scope = this;
		if (this.state.mobileno === "" || this.state.mobileno.length < 10) {
			cogoToast.warn("please fill valid mobile number", {position: 'top-center'});
		} else {
			this.setState({
				loading: true
			})
			RequestOtpMutation(data, function (response) {
				scope.setState({
					loading: false,

				})
				if (response.requestOtp.error === false) {

					// cogoToast.success(response.requestOtp.otp, {position: 'top-center'});
					setTimeout(()=>{
						scope.setUserData();
						scope.setState({...scope.state, validated: true})
					},1000)

					// console.log("validated")
				} else {
					cogoToast.error(response.requestOtp.message, {position: 'top-center'});
				}
			}, function (err) {
				scope.setState({
					loading: false

				})
				cogoToast.error(err, {position: 'top-center'});
			});
		}
	}
	setUserData = () => {
		let data = {
			user_details: {
				mobileNumber:this.state.mobileno,
				token: "",
				welcomeBonus:0,
				refreshToken: "",
				user: {}
			},
			logged_in: false,
		}
		this.props.addUserData(data);
		this.props.initCircleRotation()
		setTimeout(() => {this.setState({...this.state, trigger: false})},1000)



		setTimeout(() => {

			this.props.setLoginStep(1);
			this.props.handleLoginSteps(1);

		}, 1000)

	}
	toggleModal = () => {
		this.setState({
			open_modal: !this.state.open_modal
		});
	}
	goToPreviousPage = () => {
		// this.props.history.goBack();
		// this.props.history.push(this.props.redirect_url);
		this.props.closeLoginForm();
	}
	goToOnboardingScreen = () => {
		// this.props.history.push("/");
		// this.props.history.push(this.props.redirect_url);
		this.props.closeLoginForm();
	}
	// focusUsernameInputField = input => {
	// 	if (input) {
	// 		setTimeout(() => {input.focus()}, 1000);
	// 	}
	// };

	render() {

		const styleMNE = "mob-entry-"
		return (

			<div className="mobile-no-login-component d-flex flex-column justify-content-between px-3 pt-4 pb-3">
				<MDBBox>
					<LoginHeader
						handleBackClick={this.goToPreviousPage}
						handleCloseClick={this.goToOnboardingScreen}
					/>

					<div style={{overflowX:"hidden"}}>
						{/*<Slide right cascade opposite when={this.state.trigger}>*/}
							<div className={styleMNE + 'imageWrapper'}>
								<div className={styleMNE + 'elipse-section'}>
									<img src={netaLogo} alt={"altImage"} className={styleMNE + 'neta-logo'}/>

									<img src={envelope} alt={"altImage"} className={styleMNE + 'glossy-img'}/>

									<img src={Phone} alt={"altImage"} className={styleMNE + 'imageElement'}/>

								</div>
							</div>
						{/*</Slide>*/}

						<div className={"form-section"}>
							{/*<Slide right cascade opposite when={this.state.trigger}>*/}
								<div>
									<p className={styleMNE + 'heading my-2'}>
										To Start, Enter your Mobile Number
									</p>
									<input type="number"
									       pattern="[0-9]*"
									       maxLength={10}
									       className={styleMNE + 'inputElement my-2'}
									       value={this.state.mobileno}
									       onKeyDown={(e) => {
										       if (e.key === 'Enter') {
											       this.handleSubmit(e);
										       }
									       }}

									       // ref={this.focusUsernameInputField}
									       onChange={(e) => this.handleInpuChange(e)}
									       onInput={(e) => this.handleInpuChange(e)}
									/>
									<p className={styleMNE + "subText mt-2 mb-1"}>
										By tapping below, you agree to our
									</p>
									{/*<Slide right cascade opposite when={this.state.trigger}>*/}
									<p className={"terms-and-condition-text"} onClick={this.toggleModal}>
										T&C
									</p>
								{/*</Slide>*/}

								</div>

							{/*</Slide>*/}
						</div>

					</div>

				</MDBBox>

				<div className={styleMNE + 'buttonWrapper text-center mx-auto '}>
					<button
						className={styleMNE + "button btn  d-flex align-items-center justify-content-center my-1"}
						onClick={(e) => this.handleSubmit(e)}
						id={"submitButton-mobile"}
						disabled={this.state.loading}
					>
						<p className={"my-0 mx-2"}> Get OTP</p>
						<img src={whiteArrow} alt={'alt'} className={styleMNE + "icon"}/>
					</button>
				</div>

				<MDBModal isOpen={this.state.open_modal} toggle={this.toggleModal}>
					<MDBModalHeader toggle={this.toggleModal}>Terms & Conditions</MDBModalHeader>
					<MDBModalBody>
						<TermsAndConditionContent/>
					</MDBModalBody>
				</MDBModal>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	user_details:state.UserReducer.user_details
})

const mapDispatchToProps = dispatch => ({
	addUserData: data => dispatch(userLogin(data)),
	setLoginStep: data => dispatch(setLoginStep(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MobileNumberEntry));

